import { Pie } from "@ant-design/plots";
import React from "react";
import styled from "styled-components";

const LegendSwatch = styled.span`
  display: inline-block;
  width: 20px;
  height: 8px;
  border-radius: 8px;
  background: ${({ color }) => color || "#d9d9d9"};
`;

const DonutChart = ({ chartData, centerText }) => {
  const config = {
    data: chartData || [],
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.8,
    color: chartData ? chartData.map((item) => item.color) : [],
    label: false,
    legend: false,
    tooltip: false,
    width: 200,
    height: 200,
    statistic: {
      title: false,
      content: {
        style: {
          fontSize: "24px",
          fontWeight: 700,
          color: "#1F243B",
        },
        customHtml: () => centerText || "",
      },
    },
  };

  return (
    <div className="pie_chart_container">
      <div className="pie_chart_wrapper">
        <Pie {...config} className="w-100" />
      </div>

      <div className="chart_legents_label_container">
        {chartData?.map((item, index) => (
          <div className="chart_legents_wrapper" key={index}>
            <div className="legents_label_color_wrapper">
              <LegendSwatch color={item.color} />
              <p className="m-0 legents_label">{item.type}</p>
            </div>
            <div className="chart_legents_label">
              <p className="m-0 legents_value">{item.value}%</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChart;
